/**
 * Custom hook that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from 'gatsby';

function useCollectionGraphQL() {
  const data = useStaticQuery(
    graphql`
      {
        heroImageLadies: file(
          relativePath: { eq: "collections/ladies/hero-default-ladies.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        heroImageMens: file(
          relativePath: { eq: "collections/mens/hero-default-mens.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        cutterAndBuckHeroImage: file(
          relativePath: { eq: "collections/mens/hero-cutter-buck.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        dailySportsHeroImage: file(
          relativePath: { eq: "collections/ladies/hero-daily-sports.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        eccoHeroImage: file(
          relativePath: { eq: "collections/ladies/hero-ecco.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        fit39HeroImage: file(
          relativePath: { eq: "collections/mens/hero-fit39-gloves.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        gloveItHeroImage: file(
          relativePath: { eq: "collections/ladies/hero-glove-it.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        jamieSadockHeroImageLadies: file(
          relativePath: { eq: "collections/ladies/hero-jamie-sadock.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        jamieSadockHeroImageMens: file(
          relativePath: { eq: "collections/mens/hero-jamie-sadock.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        outerwearHeroImage: file(
          relativePath: { eq: "collections/ladies/hero-outerwear.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
        travisMathewHeroImage: file(
          relativePath: { eq: "collections/mens/hero-travis-mathew.jpg" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1280) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );
  return data;
}

export { useCollectionGraphQL };
